var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":"","outline":"","small":""},on:{"click":_vm.edit}},[_vm._v(" Edit ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }